import { useState, useEffect } from 'react';

export const conferences = [
  {
    id: 1,
    name: "Passion Conference 2025",
    location: "Atlanta, GA, USA",
    dates: "January 2–4, 2025",
    url: "https://passionconferences.com",
    startDate: new Date("2025-01-02"),
    endDate: new Date("2025-01-04"),
    description: "Focuses on uniting 18–25-year-olds for worship and teachings centered on Jesus, led by Louie Giglio and featuring Passion Music.",
    registration: "Available on www.passionconferences.com",
    ministryAffiliation: "Passion Conferences",
    streamingWebsite: "No streaming details provided; check www.passionconferences.com",
    notes: "May offer livestream; confirm with organizers.",
    imageUrl: "https://cdn.prod.website-files.com/6687371d8bcde270b5fa93b3/668b1d4c5943d95ab66a4825_Rectangle%2049.png"
  },
  {
    id: 2,
    name: "ReFuel Conference",
    location: "Mishawaka, IN, USA",
    dates: "January 17–18, 2025",
    url: "https://refuelconference.com",
    startDate: new Date("2025-01-17"),
    endDate: new Date("2025-01-18"),
    description: "Equips church worship teams with a Christ-centered approach, hosted by a Christian organization.",
    registration: "Available on www.refuelconference.com",
    ministryAffiliation: "ReFuel Conference",
    streamingWebsite: "No streaming details provided; check www.refuelconference.com",
    notes: "Likely in-person; contact for streaming updates.",
    imageUrl: "https://refuelconference.com/wp-content/uploads/2023/05/2025-01-17_refuel-conference-1292.jpg"
  },
  {
    id: 3,
    name: "Worship Together Conference",
    location: "Nashville, TN, USA",
    dates: "February 6–7, 2025",
    url: "https://www.worshiptogether.com",
    startDate: new Date("2025-02-06"),
    endDate: new Date("2025-02-07"),
    description: "Features Christian worship leaders like Chris Tomlin, focusing on worship and music for church communities.",
    registration: "Available on www.worshiptogether.com",
    ministryAffiliation: "Worship Together",
    streamingWebsite: "No streaming details provided; check www.worshiptogether.com",
    notes: "May offer virtual access; confirm with organizers.",
    imageUrl: "https://www.worshiptogether.com/media/1xnjkcl1/bwhxwt25_hisioas_coverart_op3.jpg?anchor=center&mode=crop&height=415&rnd=133833534814430000"
  },
  {
    id: 4,
    name: "PAM Worship & Music Conference – Week 1",
    location: "Montreat, NC, USA",
    dates: "June 15–20, 2025",
    url: "https://calltoworshipjournal.org/singing-around-the-table/",
    startDate: new Date("2025-06-15"),
    endDate: new Date("2025-06-20"),
    description: "Hosted by the Presbyterian Association of Musicians, focuses on Reformed Christian worship practices.",
    registration: "Available on www.calltoworshipjournal.org",
    ministryAffiliation: "Presbyterian Association of Musicians",
    streamingWebsite: "No streaming details provided; check www.calltoworshipjournal.org",
    notes: "Likely in-person; contact for streaming updates.",
    imageUrl: "https://calltoworshipjournal.org/wp-content/uploads/2022/09/CTW_main_logo_blk.png"
  },
  {
    id: 6,
    name: "United We Worship Conference",
    location: "Fullerton, CA, USA",
    dates: "July 15–16, 2025",
    url: "https://www.training-resources.org",
    startDate: new Date("2025-07-15"),
    endDate: new Date("2025-07-16"),
    description: "Listed on a Christian worship resource site, focuses on uniting worship teams for ministry.",
    registration: "Not specified; check www.training-resources.org",
    ministryAffiliation: "Evangelical Christian ministry (organizer not explicitly named)",
    streamingWebsite: "No streaming details provided; check www.training-resources.org",
    notes: "Likely Christian based on context; contact for streaming updates.",
    imageUrl: "https://www.training-resources.org/wp-content/uploads/2016/05/worshipseminar_dotcom_header_2017_G.png"
  },
  {
    id: 7,
    name: "Alleluia Conference",
    location: "Waco, TX, USA",
    dates: "July 22–25, 2025",
    url: "https://alleluia.music.baylor.edu",
    startDate: new Date("2025-07-22"),
    endDate: new Date("2025-07-25"),
    description: "Hosted by Baylor University’s Center for Christian Music Studies, focuses on worship and music training.",
    registration: "Available on www.alleluia.music.baylor.edu",
    ministryAffiliation: "Baylor University’s Center for Christian Music Studies",
    streamingWebsite: "No streaming details provided; check www.alleluia.music.baylor.edu",
    notes: "May offer virtual access; confirm with organizers.",
    imageUrl: "https://alleluia.music.baylor.edu/sites/g/files/ecbvkj1286/files/2024-07/alleluia.jpg"
  },
  {
    id: 9,
    name: "Getty Music Worship Conference",
    location: "Nashville, TN, USA",
    dates: "September 1–3, 2025",
    url: "https://gettymusicworshipconference.com",
    startDate: new Date("2025-09-01"),
    endDate: new Date("2025-09-03"),
    description: "Led by Keith and Kristyn Getty, focuses on Christian hymnody and worship practices.",
    registration: "Available on www.gettymusicworshipconference.com",
    ministryAffiliation: "Getty Music",
    streamingWebsite: "No streaming details provided; check www.gettymusicworshipconference.com",
    notes: "May offer livestream; confirm with organizers.",
    imageUrl: "https://gettymusic.store/cdn/shop/files/Sing-Album-Cover-Mid-Res.jpg?v=1710946225"
  },
  {
    id: 10,
    name: "Experience Conference",
    location: "Lake Buena Vista, FL, USA",
    dates: "September 2–5, 2025",
    url: "https://experienceconference.com",
    startDate: new Date("2025-09-02"),
    endDate: new Date("2025-09-05"),
    description: "Brings together Christian creatives and worship leaders across denominations for inspiration and training.",
    registration: "Available on www.experienceconference.com",
    ministryAffiliation: "Experience Conference",
    streamingWebsite: "No streaming details provided; check www.experienceconference.com",
    notes: "May offer virtual access; confirm with organizers.",
    imageUrl: "https://s3.amazonaws.com/media.cloversites.com/65/65b04292-fcc2-46ca-9e4d-59b74b557701/gallery/slides/3c35e08c-3bf4-4229-bcf8-ebb75835798a@2x.jpg"
  },
  {
    id: 11,
    name: "Wave Conference",
    location: "Virginia Beach, VA, USA",
    dates: "October 1–2, 2025",
    url: "https://wavechurch.com",
    startDate: new Date("2025-10-01"),
    endDate: new Date("2025-10-02"),
    description: "Hosted by Wave Church, features worship and teachings focused on Jesus.",
    registration: "Available on www.wavechurch.com",
    ministryAffiliation: "Wave Church",
    streamingWebsite: "No streaming details provided; check www.wavechurch.com",
    notes: "May offer livestream; confirm with organizers.",
    imageUrl: "https://img.imageboss.me/schuler-shook-projects/width/3000/quality:80/TP-WaveChurch-IMG_6064ps-1.jpg"
  },
  {
    id: 13,
    name: "Worship Innovators Conference",
    location: "Chicago, IL, USA",
    dates: "October 13–14, 2025",
    url: "https://worshipinnovators.com",
    startDate: new Date("2025-10-13"),
    endDate: new Date("2025-10-14"),
    description: "Provides practical training for Christian worship leaders and musicians.",
    registration: "Available on www.worshipinnovators.com",
    ministryAffiliation: "Worship Innovators",
    streamingWebsite: "No streaming details provided; check www.worshipinnovators.com",
    notes: "May offer virtual access; confirm with organizers.",
    imageUrl: "https://i0.wp.com/worshipinnovators.com/wp-content/uploads/2024/04/Screenshot-2024-04-17-at-3.01.04%E2%80%AFPM.jpg?resize=400%2C284&ssl=1"
  },
  {
    id: 14,
    name: "Christian Musician Summit",
    location: "Tacoma, WA, USA",
    dates: "November 7–8, 2025",
    url: "https://christianmusiciansummit.com",
    startDate: new Date("2025-11-07"),
    endDate: new Date("2025-11-08"),
    description: "Equips Christian musicians serving in worship and church music settings.",
    registration: "Available on www.christianmusiciansummit.com",
    ministryAffiliation: "Christian Musician Summit",
    streamingWebsite: "No streaming details provided; check www.christianmusiciansummit.com",
    notes: "May offer virtual access; confirm with organizers.",
    imageUrl: "https://christianmusiciansummit.com/uploads/1/1/5/2/115263693/img-9619_orig.jpeg"
  }
];

export const useConferenceStatus = () => {
  const [liveConferences, setLiveConferences] = useState([]);
  const [upcomingConferences, setUpcomingConferences] = useState([]);

  useEffect(() => {
    const checkConferenceStatus = () => {
      const now = new Date();
      const live = [];
      const upcoming = [];

      conferences.forEach(conference => {
        if (now >= conference.startDate && now <= conference.endDate) {
          live.push(conference);
        } else if (now < conference.startDate) {
          upcoming.push(conference);
        }
      });

      setLiveConferences(live);
      setUpcomingConferences(upcoming);
    };

    // Check status every minute
    const interval = setInterval(checkConferenceStatus, 60000);
    checkConferenceStatus();

    return () => clearInterval(interval);
  }, []);

  return { liveConferences, upcomingConferences };
};